/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseError } from '../types';
// @ts-ignore
import type { CreateDashboardBody } from '../types';
// @ts-ignore
import type { Dashboard } from '../types';
// @ts-ignore
import type { PublishedDashboard } from '../types';
// @ts-ignore
import type { UpdateDashboardBody } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
/**
 * DashboardsApi - axios parameter creator
 * @export
 */
export const DashboardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new dashboard.
         * @summary Create a dashboard
         * @param {string} extranetId 
         * @param {CreateDashboardBody} [createDashboardBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboard: async (extranetId: string, createDashboardBody?: CreateDashboardBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extranetId' is not null or undefined
            assertParamExists('createDashboard', 'extranetId', extranetId)
            const localVarPath = `/extranets/{extranet_id}/dashboards`
                .replace(`{${"extranet_id"}}`, encodeURIComponent(String(extranetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDashboardBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft deletes a dashboard.
         * @summary Delete an exising dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('deleteDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a dashboard.
         * @summary Find dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all dashboards, ordered by name.
         * @summary List all dashboards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all active, published dashboards that are part of the current extranet, and that are accessible to the current user, ordered by name.
         * @summary List all accesible dashboards for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedDashboards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/published/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publishes a dashboard.
         * @summary Publish a dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('publishDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/publications`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a dashboard.
         * @summary Update an existing dashboard
         * @param {string} dashboardId 
         * @param {UpdateDashboardBody} [updateDashboardBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard: async (dashboardId: string, updateDashboardBody?: UpdateDashboardBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDashboardBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardsApi - functional programming interface
 * @export
 */
export const DashboardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new dashboard.
         * @summary Create a dashboard
         * @param {string} extranetId 
         * @param {CreateDashboardBody} [createDashboardBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDashboard(extranetId: string, createDashboardBody?: CreateDashboardBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDashboard(extranetId, createDashboardBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardsApi.createDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft deletes a dashboard.
         * @summary Delete an exising dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardsApi.deleteDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a dashboard.
         * @summary Find dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardsApi.getDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all dashboards, ordered by name.
         * @summary List all dashboards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Dashboard>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardsApi.getDashboards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all active, published dashboards that are part of the current extranet, and that are accessible to the current user, ordered by name.
         * @summary List all accesible dashboards for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedDashboards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublishedDashboard>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedDashboards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardsApi.getPublishedDashboards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publishes a dashboard.
         * @summary Publish a dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardsApi.publishDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a dashboard.
         * @summary Update an existing dashboard
         * @param {string} dashboardId 
         * @param {UpdateDashboardBody} [updateDashboardBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDashboard(dashboardId: string, updateDashboardBody?: UpdateDashboardBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDashboard(dashboardId, updateDashboardBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardsApi.updateDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardsApi - factory interface
 * @export
 */
export const DashboardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardsApiFp(configuration)
    return {
        /**
         * Creates a new dashboard.
         * @summary Create a dashboard
         * @param {string} extranetId 
         * @param {CreateDashboardBody} [createDashboardBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboard(extranetId: string, createDashboardBody?: CreateDashboardBody, options?: RawAxiosRequestConfig): AxiosPromise<Dashboard> {
            return localVarFp.createDashboard(extranetId, createDashboardBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft deletes a dashboard.
         * @summary Delete an exising dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a dashboard.
         * @summary Find dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<Dashboard> {
            return localVarFp.getDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all dashboards, ordered by name.
         * @summary List all dashboards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboards(options?: RawAxiosRequestConfig): AxiosPromise<Array<Dashboard>> {
            return localVarFp.getDashboards(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all active, published dashboards that are part of the current extranet, and that are accessible to the current user, ordered by name.
         * @summary List all accesible dashboards for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedDashboards(options?: RawAxiosRequestConfig): AxiosPromise<Array<PublishedDashboard>> {
            return localVarFp.getPublishedDashboards(options).then((request) => request(axios, basePath));
        },
        /**
         * Publishes a dashboard.
         * @summary Publish a dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.publishDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a dashboard.
         * @summary Update an existing dashboard
         * @param {string} dashboardId 
         * @param {UpdateDashboardBody} [updateDashboardBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard(dashboardId: string, updateDashboardBody?: UpdateDashboardBody, options?: RawAxiosRequestConfig): AxiosPromise<Dashboard> {
            return localVarFp.updateDashboard(dashboardId, updateDashboardBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardsApi - object-oriented interface
 * @export
 * @class DashboardsApi
 * @extends {BaseAPI}
 */
export class DashboardsApi extends BaseAPI {
    /**
     * Creates a new dashboard.
     * @summary Create a dashboard
     * @param {string} extranetId 
     * @param {CreateDashboardBody} [createDashboardBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public createDashboard(extranetId: string, createDashboardBody?: CreateDashboardBody, options?: RawAxiosRequestConfig) {
        return DashboardsApiFp(this.configuration).createDashboard(extranetId, createDashboardBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft deletes a dashboard.
     * @summary Delete an exising dashboard
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public deleteDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return DashboardsApiFp(this.configuration).deleteDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a dashboard.
     * @summary Find dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public getDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return DashboardsApiFp(this.configuration).getDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all dashboards, ordered by name.
     * @summary List all dashboards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public getDashboards(options?: RawAxiosRequestConfig) {
        return DashboardsApiFp(this.configuration).getDashboards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all active, published dashboards that are part of the current extranet, and that are accessible to the current user, ordered by name.
     * @summary List all accesible dashboards for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public getPublishedDashboards(options?: RawAxiosRequestConfig) {
        return DashboardsApiFp(this.configuration).getPublishedDashboards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publishes a dashboard.
     * @summary Publish a dashboard
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public publishDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return DashboardsApiFp(this.configuration).publishDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a dashboard.
     * @summary Update an existing dashboard
     * @param {string} dashboardId 
     * @param {UpdateDashboardBody} [updateDashboardBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public updateDashboard(dashboardId: string, updateDashboardBody?: UpdateDashboardBody, options?: RawAxiosRequestConfig) {
        return DashboardsApiFp(this.configuration).updateDashboard(dashboardId, updateDashboardBody, options).then((request) => request(this.axios, this.basePath));
    }
}

